/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {_MAT_INK_BAR_POSITIONER_FACTORY as ɵangular_material_src_material_tabs_tabs_a} from './ink-bar';
export {MatPaginatedTabHeader as ɵangular_material_src_material_tabs_tabs_d} from './paginated-tab-header';
export {MAT_TAB_CONTENT as ɵangular_material_src_material_tabs_tabs_c} from './tab-content';
export {MAT_TAB_LABEL as ɵangular_material_src_material_tabs_tabs_b} from './tab-label';